import { j as e } from "./jsx-runtime-Bdg6XQ1m.js";
import { s as P } from "./index-LNp6rxyU.js";
import { H as _ } from "./index.esm-9-TF9KQB.js";
import { useRef as b, useState as H, useEffect as A } from "react";
import { d as I, L as N } from "./chunk-SYFQ2XB5-BF5IDYrB.js";
import { C as S } from "./CategoryHeading-MYL1u_6K.js";
import { u as $, P as L, H as g } from "./Markdown-DFN6p0J-.js";
import { b as D, d as M } from "./ZudokuContext-DeQZEp-x.js";
import { c as p } from "./cn-qaFjX9_3.js";
import { ListTreeIcon as q } from "lucide-react";
import { A as B, u as V } from "./AnchorLink-bObQitZv.js";
const R = "data-active", w = ({
  item: s,
  children: t,
  className: n,
  isActive: r
}) => /* @__PURE__ */ e.jsxs(
  "li",
  {
    className: p(
      "truncate",
      r ? "text-primary" : "text-foreground/65 dark:text-foreground/75",
      n
    ),
    title: s.value,
    children: [
      /* @__PURE__ */ e.jsx(
        B,
        {
          to: `#${s.id}`,
          [R]: s.id,
          className: p(
            r ? "text-primary" : "text-foreground/65 dark:text-foreground/75 hover:text-foreground"
          ),
          children: s.value
        }
      ),
      t
    ]
  }
), W = ({ entries: s }) => {
  const { activeAnchor: t } = $(), n = b(null), r = b(!1), [c, l] = H({
    top: 0,
    opacity: 0
  });
  return A(() => {
    if (!n.current) return;
    const o = n.current.querySelector(
      `[${R}='${t}']`
    );
    if (!o) {
      l({ top: 0, opacity: 0 });
      return;
    }
    const a = n.current.getBoundingClientRect().top, h = o.getBoundingClientRect().top;
    l({
      opacity: 1,
      top: `${h - a}px`
    }), !r.current && requestIdleCallback(() => {
      r.current = !0;
    });
  }, [t]), /* @__PURE__ */ e.jsxs("aside", { className: "sticky scrollbar top-[--header-height] h-[calc(100vh-var(--header-height))] pt-[--padding-content-top] pb-[--padding-content-bottom] overflow-y-auto ps-1 text-sm", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-2 font-medium mb-2", children: [
      /* @__PURE__ */ e.jsx(q, { size: 16 }),
      "On this page"
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "relative ms-2 ps-4", children: [
      /* @__PURE__ */ e.jsx("div", { className: "absolute inset-0 right-auto bg-border w-[2px]" }),
      /* @__PURE__ */ e.jsx(
        "div",
        {
          className: p(
            "absolute -left-px -translate-y-1 h-6 w-[4px] rounded bg-primary",
            r.current && "ease-out [transition:top_150ms,opacity_325ms]"
          ),
          style: c
        }
      ),
      /* @__PURE__ */ e.jsx(
        "ul",
        {
          ref: n,
          className: "relative font-medium list-none space-y-2",
          children: s.map((o) => /* @__PURE__ */ e.jsx(
            w,
            {
              isActive: o.id === t,
              item: o,
              className: "pl-0",
              children: o.children && /* @__PURE__ */ e.jsx("ul", { className: "list-none pl-4 pt-2 space-y-2", children: o.children.map((a) => /* @__PURE__ */ e.jsx(
                w,
                {
                  item: a,
                  isActive: a.id === t
                },
                a.id
              )) })
            },
            o.id
          ))
        }
      )
    ] })
  ] });
}, z = {
  h2: ({ children: s, id: t }) => /* @__PURE__ */ e.jsx(g, { level: 2, id: t, registerSidebarAnchor: !0, children: s }),
  h3: ({ children: s, id: t }) => /* @__PURE__ */ e.jsx(g, { level: 3, id: t, registerSidebarAnchor: !0, children: s })
}, te = ({
  mdxComponent: s,
  file: t,
  frontmatter: n = {},
  defaultOptions: r,
  tableOfContents: c,
  excerpt: l
}) => {
  var j, v, y;
  const o = (j = D()) == null ? void 0 : j.categoryLabel;
  let a = null;
  const h = I("");
  typeof window < "u" && (a = `${window.location.origin}${h}`);
  const d = n.title, u = n.category ?? o, k = n.toc === !1 || (r == null ? void 0 : r.toc) === !1, T = ((v = c.find((i) => i.depth === 1)) == null ? void 0 : v.value) ?? d, C = n.disablePager ?? (r == null ? void 0 : r.disablePager) ?? !1, f = ((y = c.find((i) => i.depth === 1)) == null ? void 0 : y.children) ?? // if `title` is provided by frontmatter it does not appear in the table of contents
  c.filter((i) => i.depth === 2), E = !k && f.length > 0, { prev: x, next: m } = M();
  return A(() => {
    if (process.env.NODE_ENV === "development")
      return window.__getReactRefreshIgnoredExports = ({ id: i }) => {
        if (i.endsWith(t))
          return ["frontmatter", "tableOfContents"];
      }, () => {
        window.__getReactRefreshIgnoredExports = void 0;
      };
  }, [t]), /* @__PURE__ */ e.jsxs("div", { className: "xl:grid grid-cols-[--sidecar-grid-cols] gap-8 justify-between", children: [
    /* @__PURE__ */ e.jsxs(_, { children: [
      /* @__PURE__ */ e.jsx("title", { children: T }),
      l && /* @__PURE__ */ e.jsx("meta", { name: "description", content: l }),
      a && /* @__PURE__ */ e.jsx("link", { rel: "canonical", href: a })
    ] }),
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: p(
          L,
          "max-w-full xl:w-full xl:max-w-prose flex-1 flex-shrink pt-[--padding-content-top] pb-[--padding-content-bottom]"
        ),
        children: [
          (u || d) && /* @__PURE__ */ e.jsxs("header", { children: [
            u && /* @__PURE__ */ e.jsx(S, { children: u }),
            d && /* @__PURE__ */ e.jsx(g, { level: 1, id: P(d), children: d })
          ] }),
          /* @__PURE__ */ e.jsx(
            s,
            {
              components: { ...V(), ...z }
            }
          ),
          !C && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx("hr", {}),
            /* @__PURE__ */ e.jsxs("div", { className: "not-prose flex flex-wrap items-center justify-between gap-2 lg:gap-8", children: [
              x ? /* @__PURE__ */ e.jsxs(
                N,
                {
                  to: x.id,
                  className: "flex flex-col items-stretch gap-2 flex-1 min-w-max border rounded px-6 py-4 text-start hover:border-primary/85 transition shadow-sm hover:shadow-md",
                  title: x.label,
                  children: [
                    /* @__PURE__ */ e.jsx("div", { className: "text-sm text-muted-foreground", children: "← Previous page" }),
                    /* @__PURE__ */ e.jsx("div", { className: "text-lg text-primary truncate", children: x.label })
                  ]
                }
              ) : /* @__PURE__ */ e.jsx("div", { className: "flex-1" }),
              m ? /* @__PURE__ */ e.jsxs(
                N,
                {
                  to: m.id,
                  className: "flex flex-col items-stretch gap-2 flex-1 min-w-max border rounded px-6 py-4 text-end hover:border-primary/85 transition shadow-sm hover:shadow-md",
                  title: m.label,
                  children: [
                    /* @__PURE__ */ e.jsx("div", { className: "text-sm text-muted-foreground", children: "Next page →" }),
                    /* @__PURE__ */ e.jsx("div", { className: "text-lg text-primary truncate", children: m.label })
                  ]
                }
              ) : /* @__PURE__ */ e.jsx("div", { className: "flex-1" })
            ] })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "hidden xl:block", children: E && /* @__PURE__ */ e.jsx(W, { entries: f }) })
  ] });
};
export {
  te as MdxPage
};
//# sourceMappingURL=MdxPage-D9c4z09Q.js.map
